import {
  RawStructure,
  Structure,
  StructureUpdatePreviewRaw,
  StructureUpdatePreview,
} from "@/types/structure";

export const mapRawToStructure = (raw: RawStructure): Structure => {
  return {
    deviceClass: raw.device_class,
    id: raw.id,
    isReferenceWaveGuide: raw.is_reference_waveguide,
    refWaveguides: raw.ref_waveguides,
    name: raw.name,
    testSiteName: raw.test_site_name,
    isCustom: raw.is_custom,
    nrOfPortCombos: raw.port_combos?.length ?? 0,
  };
};

export const mapRawToChanges = (rawChanges: any[]): any[] => {
  return rawChanges.map((change) => ({
    field: change.field,
    label: change.label,
    oldValue: change.old_value,
    newValue: change.new_value,
  }));
};

export const mapRawToStructureUpdatePreview = (
  raw: StructureUpdatePreviewRaw,
): StructureUpdatePreview => {
  return {
    structureId: raw.structure_id,
    structureName: raw.structure_name,
    message: raw.message,
    affectedMaskCount: raw.affected_mask_count,
    changes: mapRawToChanges(raw.changes),
  };
};
